import { getData, getName } from 'country-list'

export const countries = getData().map((data) => ({
  value: data.code,
  label: data.name,
}))

export const getCountryName = getName
